import React from 'react';

import { Box, Container, Grid, Theme, Typography, useMediaQuery } from '@mui/material';

import unsubscribeImage from 'assets/images/png/unsubscribe.png';
import Button from 'domains/core/components/Button';
import ErrorSnackbar from 'domains/core/components/Snackbars/ErrorSnackbar';
import SuccessSnackbar from 'domains/core/components/Snackbars/SuccessSnackbar';
import useUnsubscribe from 'hooks/mutations/useUnsubscribe';

const centerSx = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
};

const containerSx = {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: '100%',
    backgroundColor: { xs: 'white', md: 'transparent' },
    backgroundImage: { md: 'linear-gradient(to left, #a1fadb, #a1fadb)' },
    backgroundPosition: { md: 'right bottom' },
    backgroundRepeat: { md: 'no-repeat' },
    backgroundSize: { md: '26.25% 100%' },
};
/**
 * A page to confirm unsubscribe, and display a success message to the user.
 *
 * @returnsThe React node created by this component.
 */
const UnsubscribeLandingPage = () => {
    const params = new URLSearchParams(window.location.search);
    const campaignId = params.get('campaignId');
    const clientId = params.get('clientId');
    const curedId = params.get('curedId');
    const jobId = params.get('jobId');

    const hiddenMdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

    const { mutate, isSuccess, isError } = useUnsubscribe({ campaignId, clientId, curedId, jobId });

    return (
        <Container sx={containerSx}>
            {isSuccess && <SuccessSnackbar successMessage="You've been successfully unsubscribed." />}
            {isError && (
                <ErrorSnackbar errorMessage="Sorry, there was an error while processing your unsubscribe request." />
            )}
            <Grid container>
                {!hiddenMdDown && <Grid item md={1} />}
                <Grid item sm={12} md={6}>
                    <Box sx={centerSx}>
                        <Typography align="center" variant="caption" color="secondary.dark">
                            unsubscribe
                        </Typography>
                        <Typography align="center" variant="h3" mt={4} mb={4}>
                            we're sad to see you go!
                        </Typography>
                        <Typography align="center" variant="body1" mt={2} mb={6}>
                            But we value your privacy more. <br />
                            Please confirm your removal to stop receiving emails from this sender.
                        </Typography>
                        <Box>
                            <Button variant="contained" onClick={() => mutate({ status: 'unsubscribed' })}>
                                Confirm Unsubscribe
                            </Button>
                        </Box>
                    </Box>
                </Grid>
                {!hiddenMdDown && (
                    <>
                        <Grid item md={4}>
                            <Box sx={centerSx}>
                                <Box>
                                    <img src={unsubscribeImage} alt="Unsubscribe from Cured" />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item sm={1} />
                    </>
                )}
            </Grid>
        </Container>
    );
};

export default UnsubscribeLandingPage;
